import React from 'react'
import { useTranslation } from 'react-i18next'
import { BaseView, BaseText } from '@/components/base'
import { useAuthScopedStore } from '@/store/scoped'
import { StickyHeaderNavigation } from '@/components/StickyHeaderNavigation'

export const SignUpEnterVerificationCodeHeader: React.FC = () => {
  const { t } = useTranslation()

  const identificationMethod = useAuthScopedStore(
    (state) => state.identificationMethod,
  )
  const phone = useAuthScopedStore((state) => state.phone)
  const email = useAuthScopedStore((state) => state.email)

  const isPhoneMethod = identificationMethod === 'phone'

  return (
    <>
      <StickyHeaderNavigation />
      <BaseText fontSize={32} fontFamily="semibold">
        {t('screens:codeVerification.title')}
      </BaseText>
      <BaseText className="text-gray-400" color="label.description">
        {t('screens:codeVerification.subtitle', {
          method: isPhoneMethod ? 'phone number' : 'email',
          value: isPhoneMethod
            ? `${phone?.countryCode} ${phone?.number}`
            : email,
        })}
      </BaseText>
    </>
  )
}
